var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndpoin2Act(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.09 14.2H4.07998C3.03998 14.2 2.06998 13.74 1.41998 12.93L2.12998 12.35C2.60998 12.94 3.31998 13.28 4.07998 13.28H11.09C12.47 13.28 13.59 12.16 13.59 10.78V3.42C13.59 2.04 12.47 0.92 11.09 0.92H4.33998C3.57998 0.92 2.86998 1.26 2.38998 1.85L1.67998 1.27C2.32998 0.46 3.29998 0 4.33998 0H11.09C12.98 0 14.51 1.53 14.51 3.42V10.79C14.51 12.68 12.98 14.21 11.09 14.21V14.2Z",
    fill: "url(#paint0_linear_57_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 6.59003H0.77002V7.61003H14.06V6.59003Z",
    fill: "url(#paint1_linear_57_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07 9.17003C3.21323 9.17003 4.14 8.24326 4.14 7.10003C4.14 5.9568 3.21323 5.03003 2.07 5.03003C0.92677 5.03003 0 5.9568 0 7.10003C0 8.24326 0.92677 9.17003 2.07 9.17003Z",
    fill: "url(#paint2_linear_57_102)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_102",
    x1: 1.42998,
    y1: 7.1,
    x2: 14.51,
    y2: 7.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_102",
    x1: 0.77002,
    y1: 7.10003,
    x2: 14.05,
    y2: 7.10003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_102",
    x1: 0,
    y1: 0.0000295068,
    x2: 4.14,
    y2: 0.0000295068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.51,
    height: 14.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpoin2Act);
export default __webpack_public_path__ + "static/media/Endpoin2Act.ba1072059c1302cf453b92159afe1c82.svg";
export { ForwardRef as ReactComponent };